<!-- src/views/LoginView.html -->
<div class="login-container">
    <div class="login-card shadow-soft rounded-soft">
      <div class="login-header">
        <h1 class="login-title">Luna Backoffice</h1>
        <p class="login-subtitle">Accedi al tuo account</p>
      </div>

      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="email">Email</label>
          <input 
            type="text" 
            id="username" 
            v-model="username" 
            placeholder="mario.rossi@example.com" 
            required 
          />
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input 
            type="password" 
            id="password" 
            v-model="password" 
            placeholder="••••••••" 
            required 
          />
        </div>

        <button type="submit" class="submit-btn rounded-soft">
          <LogIn class="btn-icon" :size="18" />
          <span>Accedi</span>
        </button>
      </form>
    </div>
  </div>
